const theme = {
  id: "light",
  primaryColor: "#f8049c",
  secondaryColor: "#2a93ff",
  thirdColor: "#fff000",
  bodyBackgroundColor: "#fff",
  formBackgroundColor: "#ddd",
  bodyFontColor: "#000",
}

export default theme
